'use strict';

function getSelectionRaw () {
  return global.getSelection();
}

module.exports = getSelectionRaw;



//////////////////
// WEBPACK FOOTER
// ./~/seleccion/src/getSelectionRaw.js
// module id = 300
// module chunks = 0